// IDs match the customer website and entitlement records.
export const specialties = [
  { id: "anaesthetics", name: "Anaesthetics" },
  { id: "clinical-radiology", name: "Clinical Radiology" },
  { id: "core-surgical", name: "Core Surgical Training (CST)" },
  { id: "emergency-medical", name: "Emergency Medicine (ACCS)" },
  { id: "histopathology", name: "Histopathology" },
  { id: "internal-medicine", name: "Internal Medicine Training (IMT)" },
  { id: "obstetrics-gynaecology", name: "Obstetrics & Gynaecology" },
  { id: "peads-medical", name: "Paediatrics" },
];

export function specialtyName(id: string): string {
  if (id === "peads-medical") return "Paediatrics";
  return specialties.find((specialty) => specialty.id === id)?.name || id;
}
